import { html } from 'lit';
import { CrntElement } from '../../lib/crnt-element.js';
import { CrntCheckableFormControlMixin } from '../checkable-form-control/checkable-form-control.component.js';

const CrntCheckableFormControl = CrntCheckableFormControlMixin(CrntElement, { inputType: "checkbox" });
class CrntCheckbox extends CrntCheckableFormControl {
  static {
    this.tagName = "crnt-checkbox";
  }
  _renderCheckedBox() {
    return html`<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			part="icon"
		>
			<path
				d="M11.4777 15.375C11.0357 15.817 10.3527 15.817 9.91071 15.375L7.33929 12.8036C6.89732 12.3616 6.89732 11.6786 7.33929 11.2366C7.78125 10.7946 8.46429 10.7946 8.90625 11.2366L10.7143 13.0045L15.0536 8.66518C15.4955 8.22321 16.1786 8.22321 16.6205 8.66518C17.0625 9.10714 17.0625 9.79018 16.6205 10.2321L11.4777 15.375ZM3 5.57143C3 4.16518 4.125 3 5.57143 3H18.4286C19.8348 3 21 4.16518 21 5.57143V18.4286C21 19.875 19.8348 21 18.4286 21H5.57143C4.125 21 3 19.875 3 18.4286V5.57143ZM4.92857 5.57143V18.4286C4.92857 18.7902 5.20982 19.0714 5.57143 19.0714H18.4286C18.75 19.0714 19.0714 18.7902 19.0714 18.4286V5.57143C19.0714 5.25 18.75 4.92857 18.4286 4.92857H5.57143C5.20982 4.92857 4.92857 5.25 4.92857 5.57143Z"
				fill="currentColor"
			/>
		</svg>`;
  }
  _renderUncheckedBox() {
    return html`<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			part="icon"
		>
			<path
				d="M18.4286 3C19.8348 3 21 4.16518 21 5.57143V18.4286C21 19.875 19.8348 21 18.4286 21H5.57143C4.125 21 3 19.875 3 18.4286V5.57143C3 4.16518 4.125 3 5.57143 3H18.4286ZM18.4286 4.92857H5.57143C5.20982 4.92857 4.92857 5.25 4.92857 5.57143V18.4286C4.92857 18.7902 5.20982 19.0714 5.57143 19.0714H18.4286C18.75 19.0714 19.0714 18.7902 19.0714 18.4286V5.57143C19.0714 5.25 18.75 4.92857 18.4286 4.92857Z"
				fill="currentColor"
			/>
		</svg> `;
  }
}

export { CrntCheckbox };
